import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { IncidentsActivityPanelWebComponentSchema } from '../types';

export class IncidentsActivityPanelBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<IncidentsActivityPanelWebComponentSchema> {
    return {};
  }
}
